import * as React from 'react';
import { Grid } from 'react-flexbox-grid';
import { compose, withStateHandlers, lifecycle, withHandlers } from 'recompose';
import { get, isEqual } from 'lodash';
import { default as RenderToggle } from 'material-ui/Toggle';
import * as moment from 'moment';

import Date from '@inqool/uas-web-core/es/components/controls/DateTime/DateTime';
import { stringifyObject } from '@utils/utils';
import { mapUrl } from '../Map';
import { ChipInputRemote } from '@components/form';

const wrapperStyle = {
  width: '160px'
};
const DATE_FORMAT = 'YYYY-MM-DD';
const layersLabel = 'metropolis:oracle_metropolis_events_heatmap';

const typesToUrl = types => {
  if (!types.length) {
    return '';
  }
  return `types:${types.map(({ id }) => id).join('|')};`;
};

const enhance = compose<any, { handleLayers: (layers: any) => void }>(
  withStateHandlers(
    {
      active: false,
      from: moment()
        .subtract(1, 'months')
        .format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
      types: []
    },
    {
      handleStateActive: state => () => ({ ...state, active: !state.active }),
      handleStateFrom: state => from => ({ ...state, from: from && stringifyObject(from) }),
      handleStateTo: state => to => ({ ...state, to: to && stringifyObject(to) }),
      handleStateTypes: state => types => ({ ...state, types })
    }
  ),
  withHandlers({
    updateUrl: ({ handleLayers, layers }) => (newProps, oldProps) => {
      const { from: oldFrom, to: oldTo, active: oldActive, types: oldTypes } = oldProps;
      const { from: newFrom, to: newTo, active: newActive, types: newTypes } = newProps;

      if (oldFrom !== newFrom || oldTo !== newTo || oldActive !== newActive || !isEqual(oldTypes, newTypes)) {
        if (!newFrom || !newTo || !newActive) {
          handleLayers(layers.filter(({ layers: label }) => label !== layersLabel));
          return;
        }

        const url = mapUrl + `?viewParams=datetime_from:${newFrom};datetime_to:${newTo};${typesToUrl(newTypes)}`;

        handleLayers([
          ...layers.filter(({ layers: label }) => label !== layersLabel),
          {
            layers: layersLabel,
            url,
            active: true
          }
        ]);
      }
    }
  }),
  lifecycle<any, any>({
    componentDidUpdate(prevProps: any) {
      const { updateUrl } = this.props;
      updateUrl(this.props, prevProps);
    }
  })
);

const View: React.SFC<any> = ({
  handleStateFrom,
  handleStateTo,
  handleStateActive,
  handleStateTypes,
  from,
  to,
  active,
  types
}) => (
  <div>
    <Grid fluid={true}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', margin: '0 10px', alignItems: 'center' }}>
            <h4 style={{ marginRight: '5px' }}>Aktivovat</h4>
            <RenderToggle toggled={!!active} onToggle={handleStateActive} />
          </div>
          {[
            { label: 'Datum od:', name: 'dateFromEvents', onChange: handleStateFrom, value: from },
            { label: 'Datum do:', name: 'dateToEvents', onChange: handleStateTo, value: to }
          ].map(({ label, ...restProps }, i) => (
            <div key={i} style={{ display: 'flex', margin: '0 10px' }}>
              <h4 style={{ marginRight: '5px' }}>{label}</h4>
              <Date wrapperStyle={wrapperStyle} dateOnly={true} {...restProps} />
            </div>
          ))}
          <div style={{ width: '320px' }} />
        </div>
        <div style={{ display: 'flex' }}>
          <ChipInputRemote
            name="classifications"
            label="Typy událostí"
            url="/metropolis/api/ed/types"
            filterActive={true}
            labelFunction={o => get(o, 'fullName')}
            valueFunction={o => o}
            fullWidth={true}
            fullWidthInput={true}
            value={types}
            onChange={handleStateTypes}
          />
        </div>
      </div>
    </Grid>
  </div>
);

export const HeatEvents = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/maps/tabs/HeatEvents.tsx